import getHighlightedTextForSuggestion from 'owa-search/lib/utils/getHighlightedTextForSuggestion';
import highlightDisplayText from 'owa-search/lib/utils/highlightDisplayText';
import React from 'react';
import sonoraCommonStyles from './SonoraCommonStyles.scss';
import classnamesBind from 'classnames/bind';
const classNames = classnamesBind.bind(sonoraCommonStyles);
interface SonoraResultsItemProps {
    isHighlighted: boolean;
    icon: JSX.Element;
    primaryText: string;
    secondaryText: string;
    tooltip: string;
    rootId: string;
    onClickAction: () => void;
    onMouseEnterAction: () => void;
    detailMenuIcon?: JSX.Element;
}

const SonoraResultsItem = (props: SonoraResultsItemProps): JSX.Element => {
    const {
        isHighlighted,
        icon,
        primaryText,
        secondaryText,
        tooltip,
        rootId,
        onClickAction,
        onMouseEnterAction,
        detailMenuIcon,
    } = props;
    const primaryTextToHighlight = highlightDisplayText(primaryText);
    const secondaryTextToHighlight = highlightDisplayText(secondaryText);

    return (
        <div
            id={rootId}
            className={classNames(sonoraCommonStyles.hoverable, { isHighlighted: isHighlighted })}>
            <div
                className={sonoraCommonStyles.suggestionButtonContainer}
                onClick={onClickAction}
                onMouseEnter={onMouseEnterAction}
                title={tooltip}>
                <div className={sonoraCommonStyles.suggestionButtonIconContainer}>{icon}</div>
                <div className={sonoraCommonStyles.suggestionButtonTextContainer}>
                    <div className={sonoraCommonStyles.suggestionButtonPrimaryText}>
                        {getHighlightedTextForSuggestion(primaryTextToHighlight)}
                    </div>
                    <div className={sonoraCommonStyles.suggestionButtonSecondaryText}>
                        {getHighlightedTextForSuggestion(secondaryTextToHighlight)}
                    </div>
                </div>
                {detailMenuIcon && detailMenuIcon}
            </div>
        </div>
    );
};

export default SonoraResultsItem;
